import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { IRootScope } from "../../types/rootScope";

@Injectable({ providedIn: 'root' })
export class RootScope implements IRootScope {

    private _largeScreenSubject = new BehaviorSubject<boolean>(false);
    private _mainSearchActiveSubject = new BehaviorSubject<boolean>(false);
    private _pageLoadingSubject = new BehaviorSubject<boolean>(false);
    private _pageLoadedSubject = new BehaviorSubject<boolean>(false);
    private _appInitializedSubject = new BehaviorSubject<boolean>(false);
    private _card_fullscreenSubject = new BehaviorSubject<boolean>(false);

    public readonly largeScreenChange = this._largeScreenSubject.asObservable();
    /** @deprecated */
    public readonly mainSearchActiveChange = this._mainSearchActiveSubject.asObservable();
    public readonly pageLoadingChange = this._pageLoadingSubject.asObservable();
    public readonly pageLoadedChange = this._pageLoadedSubject.asObservable();
    public readonly appInitializedChange = this._appInitializedSubject.asObservable();
    /** @deprecated */
    public readonly card_fullscreenChange = this._card_fullscreenSubject.asObservable();

    constructor() {}

    public get largeScreen(): boolean { return this._largeScreenSubject.value }
    public set largeScreen(value: boolean) {
        this._largeScreenSubject.next(value);
    }

    /** @deprecated */
    public get mainSearchActive(): boolean { return this._mainSearchActiveSubject.value }
    public set mainSearchActive(value: boolean) {
        this._mainSearchActiveSubject.next(value);
    }

    public get pageLoading(): boolean { return this._pageLoadingSubject.value }
    public set pageLoading(value: boolean) {
        this._pageLoadingSubject.next(value);
    }

    public get pageLoaded(): boolean { return this._pageLoadedSubject.value }
    public set pageLoaded(value: boolean) {
        this._pageLoadedSubject.next(value);
    }

    public get appInitialized(): boolean { return this._appInitializedSubject.value }
    public set appInitialized(value: boolean) {
        this._appInitializedSubject.next(value);
    }

    /** @deprecated use **cardFullScreen** instead */
    public get card_fullscreen(): boolean { return this._card_fullscreenSubject.value }
    public set card_fullscreen(value: boolean) {
        this._card_fullscreenSubject.next(value);
    }

    /** @deprecated */
    public get cardFullScreen(): boolean { return this._card_fullscreenSubject.value }
    public set cardFullScreen(value: boolean) {
        this._card_fullscreenSubject.next(value);
    }
}
